<template>
  <div>
    <el-dialog title="兑换码批次" center :visible="true" @close="onClose" :close-on-click-modal="false"
      :close-on-press-escape="false" width="1686px">
      <div>
        <h3>礼包：{{ this.form.giftName }}</h3>
        <el-dropdown trigger="click" @command="onClickBatchExportBtn" style="margin-bottom: 10px;">
          <el-button type="primary" plain>批量导出</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ type: '常规格式' }">常规格式</el-dropdown-item>
            <el-dropdown-item :command="{ type: 'taptap格式' }">taptap格式</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-table :data="list" :row-class-name="tableRowClassName" border v-el-table-infinite-scroll="loadMore"
        :infinite-scroll-disabled="list.length == 0" size="small" style="width: 1601px">
        <el-table-column width="35">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.isSelected" @click.shift.native="onShiftClick(scope.row)"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="时间" align="center" width="140">
          <template slot-scope="scope">
            {{ $util.ms2datetime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="round" label="批次号" align="center" width="70">
        </el-table-column>
        <el-table-column prop="adminUsername" label="生成人" align="center" width="120">
        </el-table-column>

        <el-table-column prop="useCount" label="自定义兑换码" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.customRedeemCode ? scope.row.customRedeemCode : "" }}
          </template>
        </el-table-column>

        <el-table-column prop="count" label="生成兑换码数量" align="center" width="120">
        </el-table-column>

        <el-table-column prop="useCount" label="单个兑换码可被使用次数" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.useCount == 0 ? "无限次" : scope.row.useCount }}
          </template>
        </el-table-column>
        <el-table-column label="本批次仅可被同一玩家使用一次" align="center" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.availableRedeemTimes" style="color: red">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="适用渠道" align="center" width="120">
        </el-table-column>

        <el-table-column prop="startAt" label="生效日期（当天零点生效）" align="center" width="165">
          <template slot-scope="scope">
            {{
              scope.row.startAt != "0" ? $util.ms2day(scope.row.startAt) : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="endAt" label="失效日期（当天零点失效）" align="center" width="165">
          <template slot-scope="scope">
            {{ scope.row.endAt != "0" ? $util.ms2day(scope.row.endAt) : "" }}
          </template>
        </el-table-column>

        <el-table-column prop="remark" show-overflow-tooltip label="备注" align="center" width="200">
        </el-table-column>

        <el-table-column label="操作" align="center" width="170">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="remove(scope.row)">删除</span>

            <el-dropdown trigger="click" @command="onClickExportBtn">
              <span class="link-button"> 导出 </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: '常规格式', entry: scope.row }">常规格式</el-dropdown-item>
                <el-dropdown-item :command="{ type: 'taptap格式', entry: scope.row }">taptap格式</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const luxon = require("luxon");
const fileDownload = require("js-file-download");
import JsFileDownloader from 'js-file-downloader';
import store from "@/store";
// 本弹窗名称
const DialogName = "RedeemCodeGiftDetailsDialog";

export default {
  data() {
    return {
      list: [],
      form: {
        giftId: "",
        currentCycleId: "",
        giftName: "",
      },
    };
  },
  components: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.giftId = value.entry.id;
    this.form.giftName = value.entry.name;
    if (value.entry.currentCycleId) {
      this.form.currentCycleId = value.entry.currentCycleId;
    }
    await this.loadList(0, 50);
  },

  methods: {
    onShiftClick(row) {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].isSelected) {
          for (let j = i + 1; j < this.list.length; j++) {
            if (this.list[j].round <= row.round) {
              break;
            }

            if (!this.list[j].isSelected) {
              this.list[j].isSelected = true;
            }
          }

          break;
        }
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.id == this.form.currentCycleId) {
        return "selected-row";
      }
      return "";
    },

    async loadMore() {
      await this.loadList(this.list.length, 50);
    },
    /**
     * 拉取集合
     */
    async loadList(skip, limit) {
      if (skip == 0) {
        this.list = [];
      }
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryRedeemCodeCycle`,
          {
            giftId: this.form.giftId,
            skip: skip,
            limit,
            limit,
          },
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      for (let item of listInResponse) {
        item.isSelected = false;
      }

      this.list = this.list.concat(listInResponse);
    },

    /**
     * 提交表单
     */
    submit() {
      this.add();
    },

    async onClickExportBtn(command) {
      // 弹确认框
      await this.$confirm(`确认导出兑换码？`);

      this.exportCode(command.entry, command.type);
    },

    async onClickBatchExportBtn(command) {
      let selectedList = [];
      for (let item of this.list) {
        if (item.isSelected) {
          selectedList.push(item);
        }
      }

      if (selectedList.length == 0) {
        this.$message.error("请先选择要导出的批次");
        return;
      }

      // 弹确认框
      await this.$confirm(`导出已选择的共${selectedList.length}个批次的兑换码？`);

      selectedList.sort((a, b) => a.round - b.round);
      await this.exportCycles(command.type, selectedList.map(item => item.id));

      this.$message.success("批量导出完成");
    },

    /**
     * 批量导出
     */
     async exportCycles(type, cycleIds) {
      let downloadFileName = `${store.projectInfo.name}_${this.form.giftName
        }_兑换码_${luxon.DateTime.now().toFormat(
          "yyyyMMddHHmmss"
        )}_${type}.zip`;

      let url = `${this.$util.getBackendApiBase()}/v1/admin/exportRedeemCodeCycles?type=${type}&cycleIds=${cycleIds.join(",")}`;

      const download = new JsFileDownloader({
        url: url,
        headers: [
          { name: "token", value: this.$bizutil.getLoginUserToken(), }
        ],
        filename: downloadFileName,
        autoStart: false,
      });

      await download.start();
    },    

    /**
     * 导出
     */
    async exportCode(entry, type) {
      let downloadFileName = `${store.projectInfo.name}_${this.form.giftName
        }_兑换码_批次${entry.round}_${luxon.DateTime.fromMillis(Number(entry.createdAt)).toFormat(
          "yyyyMMddHHmmss"
        )}_${type}.xlsx`;

      let url = `${this.$util.getBackendApiBase()}/v1/admin/exportRedeemCodeCycle?cycleId=` +
        entry.id +
        `&type=` +
        type;

      const download = new JsFileDownloader({
        url: url,
        headers: [
          { name: "token", value: this.$bizutil.getLoginUserToken(), }
        ],
        filename: downloadFileName,
        autoStart: false,
      });

      await download.start();

      /*
      let resData = (
        await axios.get(
          url,
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
            responseType: "blob",
          }
        )
      ).data;

      fileDownload(
        resData,
        downloadFileName,
      );
      */
    },

    /**
     * 删除礼包
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除批次`, {
          type: "warning",
        });

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delRedeemCodeCycle`,
            {
              cycleId: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) { }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table .selected-row {
  background: #f1ad54;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}

.link-button {
  padding-left: 10px;
  font-size: 12px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>